import { OpPatch } from "json-patch";
import { Axios } from "../../Axios";
import { TypeAlergia } from "../../../Models/Domain/Saude/Alergia";

export interface IFiltro {
    codigo?: number,
    ativo?: boolean,
    nome?: string,
    descricao?: string,
}

export class AlergiaService {
    public static listar(filtro?: IFiltro){
        return Axios.get<TypeAlergia[]>(`quiron/saude/alergia`, {params: filtro});
    }

    public static atualizar(payload: TypeAlergia){
        return Axios.put<void>(`quiron/saude/alergia`, payload);
    }

    public static atualizarComPatch(codigo: number, payload: OpPatch){
        return Axios.patch<void>(`quiron/saude/alergia/${codigo}`, payload);
    }

    public static inserir(payload: TypeAlergia){
        return Axios.post<void>(`quiron/saude/alergia`, payload);
    }

    public static desativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/alergia/${codigo}/desativar`);
    }

    public static ativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/alergia/${codigo}/ativar`);
    }
}